import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);
dayjs.extend(timezone);

const DATE_FORMAT = "YYYY-MM-DD";

export const getServerDateRange = (type, serverTimezone) => {
  const now = dayjs().tz(serverTimezone);

  switch (type) {
    case "today":
      return [now.format(DATE_FORMAT), now.format(DATE_FORMAT)];
    case "yesterday": {
      const yesterday = now.add(-1, "d");
      return [yesterday.format(DATE_FORMAT), yesterday.format(DATE_FORMAT)];
    }
    case "sevenDays":
      return [now.add(-7, "d").format(DATE_FORMAT), now.format(DATE_FORMAT)];
    case "fifteenDays":
      return [now.add(-15, "d").format(DATE_FORMAT), now.format(DATE_FORMAT)];
    case "thirtyDays":
      return [now.add(-30, "d").format(DATE_FORMAT), now.format(DATE_FORMAT)];
    default:
      return [now.format(DATE_FORMAT), now.format(DATE_FORMAT)];
  }
};
